import { render, staticRenderFns } from "./price-wrapper.vue?vue&type=template&id=5ec8b8fc&"
import script from "./price-wrapper.vue?vue&type=script&lang=js&"
export * from "./price-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports